import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconUser: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconUser"><Path d="M7.5 20.25C5.84315 20.25 4.44049 18.8728 4.9469 17.2952C5.86949 14.4212 8.22053 12.25 12 12.25C15.7765 12.25 17.9842 14.4178 18.8385 17.2885C19.3111 18.8765 17.9069 20.25 16.25 20.25H7.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><Circle cx="12" cy="7.75" r="4.5" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconUser;
